import api from './api';

export const getLeavePolicies = (params) => api.get('/v1/leave-policies', { params });
export const getLeavePolicy = (id) => api.get(`/v1/leave-policies/${id}`);
export const createLeavePolicy = (data) => api.post('/v1/leave-policies', data);
export const updateLeavePolicy = (id, data) => api.put(`/v1/leave-policies/${id}`, data);
export const deleteLeavePolicy = (id) => api.delete(`/v1/leave-policies/${id}`);
export const setVariations = (id, data) => api.put(`/v1/leave-policies/${id}/variations`, data);
export const assignUsers = (id, data) => api.post(`/v1/leave-policies/${id}/assign`, data);
export const getPolicyUsers = (id, params) => api.get(`/v1/leave-policies/${id}/users`, { params });
export const removeUser = (id, userId) => api.delete(`/v1/leave-policies/${id}/users/${userId}`);
export const removeAllUsers = (id, ids) => api.delete(`/v1/leave-policies/${id}/users`, { data: { ids } });
